"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// import React, { memo, FC } from 'react';
const React = __importStar(require("react"));
const mui_1 = require("tss-react/mui");
const react_1 = require("@emotion/react");
const material_1 = require("@mui/material");
const Add_1 = __importDefault(require("@mui/icons-material/Add"));
const compose_1 = __importDefault(require("utils/compose"));
const LoadingView_1 = __importDefault(require("components/LoadingView"));
const ZeroStateView_1 = __importDefault(require("components/ZeroStateView"));
const helpers_1 = require("containers/OverviewPage/components/helpers");
const under_construction_png_1 = __importDefault(require("assets/under-construction.png"));
const settings_svg_1 = __importDefault(require("assets/nav-menu/settings.svg")); // TODO: replace with real icon
const styles_1 = __importDefault(require("./styles"));
const useStyles = (0, mui_1.makeStyles)()(styles_1.default);
const LoadingAndEmptyScheduledTxnsViews = ({ view, dispatchDoAccountDiscoveryAction, }) => {
    const { classes } = useStyles();
    const renderDisabledState = () => <img alt="page is under construction" src={under_construction_png_1.default} className={classes.disabledView}/>;
    const renderLoadPendingState = () => <ZeroStateView_1.default className={classes.margin40} primary="No Data" icon={settings_svg_1.default} secondary="We can't fetch your data from the server. Please try to refresh the page." size="small"/>;
    const renderZeroState = () => (<ZeroStateView_1.default className={classes.margin40} icon={settings_svg_1.default} secondary="You don't have any accounts set up." size="small">
      <material_1.IconButton aria-label="add account" color="primary" onClick={() => dispatchDoAccountDiscoveryAction()} size="large">
        <Add_1.default />
      </material_1.IconButton>
    </ZeroStateView_1.default>);
    const renderEmptyState = () => (<div>
      <ZeroStateView_1.default className={classes.margin40} primary="No Data" icon={settings_svg_1.default} secondary="Let's get started." size="small"/>
    </div>);
    return (<>
      {view === helpers_1.ViewStateEnum.ZERO && renderZeroState()}
      {view === helpers_1.ViewStateEnum.EMPTY && renderEmptyState()}
      {view === helpers_1.ViewStateEnum.DISABLED && renderDisabledState()}
      {view === helpers_1.ViewStateEnum.LOAD_PENDING && renderLoadPendingState()}
      {view === helpers_1.ViewStateEnum.LOADING && <LoadingView_1.default className={classes.margin40}/>}
    </>);
};
exports.default = (0, compose_1.default)(react_1.withTheme)(React.memo(LoadingAndEmptyScheduledTxnsViews));
